import {getFont} from "@core-ui/react-stitch";
import {DropdownStyleFn} from "../types";

export const dropdownCSS: DropdownStyleFn = ({theme, crossBrand}) => ({
  ...getFont("primary")({theme, crossBrand}),
  width: "100%",
  position: "relative",
});
